import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService, httpOptions } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ScheduledMeetingResourceTypeMappings } from '@aa/nest/resource';

@Injectable()
export class ScheduledMeetingService extends BaseResourceService<ScheduledMeetingResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'scheduled-meetings');
  }

  approveMeeting(
    id: ScheduledMeetingResourceTypeMappings['resourcePrimaryKeyT'],
  ) {
    const idSlug = this.getPrimaryKeyIdSlug(id);

    return this.http.post<ScheduledMeetingResourceTypeMappings['resourceT']>(
      `${this.endpoint}/${this.resourceSlug}${idSlug}/approve`,
      {},
      {
        ...httpOptions,
      },
    );
  }

  rejectMeeting(
    id: ScheduledMeetingResourceTypeMappings['resourcePrimaryKeyT'],
  ) {
    const idSlug = this.getPrimaryKeyIdSlug(id);

    return this.http.post<ScheduledMeetingResourceTypeMappings['resourceT']>(
      `${this.endpoint}/${this.resourceSlug}${idSlug}/reject`,
      {},
      {
        ...httpOptions,
      },
    );
  }

  cancelMeeting(
    id: ScheduledMeetingResourceTypeMappings['resourcePrimaryKeyT'],
  ) {
    const idSlug = this.getPrimaryKeyIdSlug(id);

    return this.http.post<ScheduledMeetingResourceTypeMappings['resourceT']>(
      `${this.endpoint}/${this.resourceSlug}${idSlug}/cancel`,
      {},
      {
        ...httpOptions,
      },
    );
  }
}
